import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Drawer, Modal, Message, Button, Space, Typography } from '@bedrock/components';
import withFunctionCall from '#utils/withFunctionCall';
import styles from './index.less';
import classNames from 'classnames/bind';
import ClosingReportTable from '../ClosingReportTable';
import { apiService } from '#services';
import { ClosingReportProps } from '../ClosingReportTable';
import { Save } from '@bedrock/icons-react';
import { useMemoizedFn } from 'ahooks';

const cx = classNames.bind(styles);

type ClosingReportTableModalProps = {
  onOk: (data: any) => void;
  onCancel: () => void;
} & Omit<ClosingReportProps, 'onChange'>

function ClosingReportTableModal({ onOk, onCancel, ...props }: ClosingReportTableModalProps) {
  const { view, cooperateAccountId, detail } = props;
  const [loading, setLoading] = useState(false);
  const tableRef = useRef<any>(null)

  const title = useMemo(() => {
    if (!cooperateAccountId) return '结案明细';
    const cooperateIndexId = detail?.demand_plan_info?.cooperate_accounts?.find((item) => item.id === cooperateAccountId)?.index_id;
    return `合作内容${cooperateIndexId ? `${cooperateIndexId}` : ''}-结案明细`;
  }, [cooperateAccountId, detail])

  // 处理待提交数据
  const handleSubmit = useMemoizedFn((list: any[]) => {
    return list?.filter((item) => !!item?.quote_key).map((item) => {
      return {
        ...item,
        content: item?.content?.trim(),
        attach_blob_ids: item?.attachments?.map((n: any) => n?.blob?.id || n?.id).filter(Boolean)
      }
    })
  })

  return <Drawer
    title={title}
    width={'100vw'}
    height={'100vh'}
    visible={true}
    closable={!loading}
    className={cx('closing-report-table-modal')}
    onClose={() => {
      onCancel?.()
    }}
  >
    <div className={cx('layout')}>
      <div className={cx('content')}>
        <ClosingReportTable {...props} ref={tableRef} />
      </div>
      <div className={cx('footer')} >
        <Space size={4}>
          {/* <Typography.Text type="secondary">报价金额-优惠前 (含税+服务费):</Typography.Text>
          <CurrencyType
            view
            value={{
              value: detail?.total_price,
              currency: detail?.currency
            }} /> */}
        </Space>
        {!view && <Space size={12}>
            <Button
              type="checked-neutral"
              icon={<Save />}
              loading={loading}
              onClick={async () => {
                setLoading(true)
                try {
                  const data = tableRef.current?.getFieldsValue?.()
                  const reportList = handleSubmit(data?.closingReportList)
                  onOk?.(reportList)
                  await apiService.outsourceDemandSaveStructuredSettleReportsData({
                    demand_id: detail?.id,
                    quote_settle_reports: reportList,
                  })
                  Message.success('暂存成功')
                  setLoading(false)
                } catch (error) {
                  setLoading(false)
                }
            }}>
              暂存
            </Button>
            <Button type='primary' loading={loading} onClick={async () => {
              setLoading(true)
              try {
                const data = await tableRef.current?.validateFields?.()
                onCancel?.()
                const reportList = handleSubmit(data?.closingReportList)
                onOk?.(reportList)
                await apiService.outsourceDemandSaveStructuredSettleReportsData({
                  demand_id: detail?.id,
                  quote_settle_reports: reportList,
                })
                setLoading(false)
              } catch (error) {
                setLoading(false)
              } 
            }}>
              确定
            </Button>
          </Space>}
      </div>
    </div>
  </Drawer >
}

export default withFunctionCall(ClosingReportTableModal);
